import PropTypes from 'prop-types'
import React from 'react'

function WatchAccessAllowed (props) {
  return <>{props.children}</>
}

WatchAccessAllowed.propTypes = {
  access: PropTypes.string,
}

export default React.memo(WatchAccessAllowed)
